import { Select } from "antd";
import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";
import { localeEndonym } from "@/shared/utils/locale.utils";

interface LanguagePickerProps {
  availableLocales: LanguagesIsoEnum[];
  // value/onChange are injected by antd Form.Item when this is wrapped in one.
  value?: LanguagesIsoEnum;
  onChange?: (locale: LanguagesIsoEnum) => void;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
}

export default function LanguagePicker({
  availableLocales,
  value,
  onChange,
  placeholder,
  loading = false,
  disabled = false,
}: LanguagePickerProps) {
  return (
    <Select<LanguagesIsoEnum>
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={availableLocales.map((locale) => ({
        value: locale,
        label: localeEndonym(locale),
      }))}
    />
  );
}
